import { getTenantData } from '../lib/tenantContext';
import { messages } from './messages';
import { uiMessagesNl } from './uiMessagesNl.mjs';

const SUPPORTED = new Set(['en', 'nl']);

const legacyCodes = new Map([
  ['unauthenticated.', 'auth.unauthenticated'],
  ['invalid credentials.', 'auth.invalid_credentials'],
  ['validation failed.', 'request.validation_failed'],
  ['too many requests.', 'request.rate_limited'],
  ['payment not found.', 'payment.not_found'],
  ['insufficient funds.', 'payment.insufficient_funds'],
  ['insufficient credits.', 'payment.insufficient_funds'],
  ['subscription not found.', 'subscription.not_found'],
  ['conversation not found.', 'chat.conversation_not_found'],
  ['verification request not found.', 'verification.not_found'],
  ['verification request expired.', 'verification.expired'],
]);

export function resolveLocale(explicitLocale = null) {
  let accountLocale = null;
  try {
    const user = JSON.parse(localStorage.getItem('user_data') || 'null');
    accountLocale = user?.locale;
  } catch {
    accountLocale = null;
  }

  const tenant = getTenantData();
  for (const candidate of [
    explicitLocale,
    accountLocale,
    tenant?.locale,
    tenant?.config?.locale,
  ]) {
    const normalized = String(candidate || '').trim().toLowerCase().split(/[-_]/)[0];
    if (SUPPORTED.has(normalized)) return normalized;
  }

  return 'en';
}

export function t(key, params = {}, locale = null) {
  const resolved = resolveLocale(locale);
  const uiTemplate = Object.hasOwn(uiMessagesNl, key)
    ? (resolved === 'nl' ? uiMessagesNl[key] : key)
    : null;
  const template = messages[resolved]?.[key]
    ?? messages.en[key]
    ?? uiTemplate
    ?? messages.en['general.unavailable'];

  return Object.entries(params).reduce(
    (value, [name, replacement]) => value.replaceAll(`:${name}`, String(replacement)),
    template
  );
}

export function gatewayErrorMessage(payload, locale = null) {
  const suppliedCode = payload?.data?.message_code;
  const code = typeof suppliedCode === 'string' && messages.en[suppliedCode]
    ? suppliedCode
    : legacyCodes.get(String(payload?.message || payload?.error || '').trim().toLowerCase());
  const params = payload?.data?.message_params;

  return t(code || 'general.unavailable', params && typeof params === 'object' ? params : {}, locale);
}

export function statusLabel(status, locale = null) {
  return t(`status.${String(status || '').toLowerCase()}`, {}, locale);
}
